import React from 'react';
import PropTypes from 'prop-types';
import ModuleBlock from "../ModuleBlock";
import ModuleService from "../../../../../services/module";

class ReportModuleBlock extends React.Component {
    static propTypes = {
        app: PropTypes.object.isRequired
    };

    render() {
        return (
            <ModuleBlock app={this.props.app} module={ModuleService.getModule(ModuleService.REPORT)}/>
        );
    }
}

export default ReportModuleBlock;



// WEBPACK FOOTER //
// src/components/application/ApplicationFull/ModuleBlock/ReportModuleBlock/ReportModuleBlock.js